import BoxModal from './main'
export default function (Vue) {
  Vue.component(BoxModal.name, BoxModal)
}



// WEBPACK FOOTER //
// ./src/components/modal/index.js